import FactoryBoxContainer from './View/FactoryBoxContainer.view';
export default FactoryBoxContainer;
